import React from 'react';
import { MicrophoneIcon } from '@heroicons/react/20/solid';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../app/hooks';
import { setForumFilterProfile } from '../../forum/questions-list/forumQuestionsSlice';
import { RootState } from '../../../app/store';

export default function FeedPosts() {

  const history = useHistory();
  const dispatch = useAppDispatch();

  const { currentlyLoadedProfileID } = useSelector((state: RootState) => state.profilePage);

  if (! currentlyLoadedProfileID) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => {
          dispatch(setForumFilterProfile(currentlyLoadedProfileID || null));
          history.push(`/feed/profile/${currentlyLoadedProfileID}`);
        }}
        className="inline-flex items-center justify-center px-4 py-2 border border-neutral-300 shadow-sm text-sm font-medium rounded-md text-neutral-700 bg-white hover:bg-neutral-50 focus:outline-none "
      >
        <MicrophoneIcon className="-ml-1 mr-2 h-5 w-5 text-gray-400" aria-hidden="true" />
        <span>Feed Posts</span>
      </button>
    </>
  );
}
